import { graphql } from "../generated";

// The deliverable as the revision surfaces read it — the canonical facts the
// federated entity carries plus the revision subgraph's own contributions
// (the overlay URLs, the concept notes and the project link). One selection
// for every single-deliverable read site so the presented-status facts
// (verdict, the audience latch, the viewer's head election) travel with every read:
// docs/revision-deliverable-graph-thinning/SCOPE.md, D3 and D4, composed per
// docs/deliverable-status-seam/SCOPE.md (Train A).
export const ReviewDeliverableDocument = graphql(`
  query ReviewDeliverable($key: ID!) {
    deliverable(key: $key) {
      key
      projectKey
      conceptKey
      specificationKey
      verdict
      # The viewer's own election: the presented status (D4) keys SUPERSEDED on
      # a delivered row that is not the head.
      isHead
      hasReachedReviewStage
      hero
      copyVariationNumber
      unitNumber
      languageCode
      duration
      width
      height
      bitrate
      framesPerSecond
      file {
        key
        fileName
        contentType
      }
      specification {
        key
        progressStatus
        language {
          name
          code
        }
        format {
          key
          name
          length
          platform {
            code
            name
          }
        }
      }
      placementOverlayUrl: overlayUrl(type: Placement)
      safezoneOverlayUrl: overlayUrl(type: Safezone)
      revisionConcept {
        id
        key
        additionalNotes
        heroNotes
        project {
          key
          name
          serialId
        }
      }
    }
  }
`);
